import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './404.scss';

class NotFoundContainer extends Component {
  componentDidMount() {
    document.title = 'Ouch! Page not found - Cellit.io';
  }

  render() {
    return(
      <section className="not-found">
        <div className="wrapper">
          <div className="text-wrapper">
            <h1 className="title">404</h1>
            <p className="subtitle">Página não encontrada</p>
            
            <Link to="/" className="btn btn-blue">Voltar para Dashboard</Link>
          </div>
        </div>
      </section>
    )
  }
}

export { NotFoundContainer as NotFound };